import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faStop as faStopDuotone } from '@fortawesome/pro-duotone-svg-icons';
import { faStop as faStopSolid } from '@fortawesome/pro-solid-svg-icons';
import { SkillConfigurationRemoteDto } from 'src/generated/signalR/skill-configuration-remote-dto';
import { Skill } from '../../../../../store/samwin/samwin-skills/skill';

@Component({
   selector: 'samweb-skill-short-info-icon',
   templateUrl: './skill-short-info-icon.component.html',
   styleUrls: ['./skill-short-info-icon.component.scss'],
})
export class SkillShortInfoIconComponent implements OnInit {
   @Input()
   public skills: Skill[];
   @Input()
   public skillConfiguration: SkillConfigurationRemoteDto;

   public skillColorIcon: IconDefinition = faStopDuotone;
   public skillColorBorderIcon: IconDefinition = faStopSolid;

   constructor() {}

   ngOnInit(): void {}
}
